import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-img-dialog',
  standalone: true,
  imports: [],
  templateUrl: './img-dialog.component.html',
  styleUrl: './img-dialog.component.scss'
})
export class ImgDialogComponent {
  imgUri: any;
  constructor(@Optional() @Inject(MAT_DIALOG_DATA) data: any) {
    this.imgUri = data;
  }
}
